import Vue from "vue";
import { hasPermission } from "@/utils/permission";

/**
 * @description 权限点指令v-perm
 */
Vue.directive("perm", {
  inserted(el, binding) {
    const { value } = binding;
    if (value) {
      if (!hasPermission(value)) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    }
  },
});
